var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},_vm._l((_vm.statData),function(stat){return _c('div',{key:stat.icon,staticClass:"col-12"},[_c('Stat',{attrs:{"icon":stat.icon,"title":stat.title,"value":stat.value}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }